// TODO: Consolidate with <Confirm /> component
import React from 'react';
import { bool, string, func, node } from 'prop-types';
import { Button, Modal, Icon } from 'semantic-ui-react';
import styled from 'styled-components';

const ActionSection = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px 20px;
    margin-bottom: 5px;
    border-top: 1px solid ${p => p.theme.color.starkiller};
`;

const propTypes = {
    isOpen: bool,
    onClose: func,
    className: string,
    children: node,
    hideCloseButton: bool,
    showCancelButton: bool,
    title: string,
    handleDone: func,
    submitButtonText: string,
    showSubmitButton: bool,
    extraContent: node,
    disableSubmitButton: bool,
};

const defaultProps = {
    className: '',
    onClose: () => {},
    submitButtonText: 'Submit',
    showSubmitButton: true,
    showCancelButton: true,
    disableSubmitButton: false,
};

const ModalCustom = ({
    className,
    isOpen,
    children,
    onClose,
    hideCloseButton,
    showCancelButton,
    title,
    handleDone,
    showSubmitButton,
    submitButtonText,
    disableSubmitButton,
    extraContent,
}) => (
    <Modal
        open={isOpen}
        onClose={onClose}
        className={className}
        closeIcon={hideCloseButton ? null : <Icon name="close" />}
        closeOnDimmerClick={false}
    >
        {
            title && <Modal.Header>{ title }</Modal.Header>
        }
        <Modal.Content scrolling>
            { children }
        </Modal.Content>
        <div>{ extraContent }</div>
        {
            (showCancelButton || showSubmitButton) && (
                <ActionSection>
                    { showCancelButton && <Button onClick={onClose} > Cancel</Button> }
                    {
                        showSubmitButton && (
                            <Button disabled={disableSubmitButton} onClick={handleDone} primary>
                                { submitButtonText } <Icon name="chevron right" />
                            </Button>
                        )
                    }
                </ActionSection>
            )
        }
    </Modal>
);

ModalCustom.propTypes = propTypes;

ModalCustom.defaultProps = defaultProps;

export default ModalCustom;
